import type React from "react"

const TEMPLATE_DOCUMENT_TYPES = {
  PROPOSAL_CONTRACT: "proposal_contract",
  PROPOSAL: "proposal",
  CONTRACT: "contract"
} as const

type TemplateDocumentTypesKeys = keyof typeof TEMPLATE_DOCUMENT_TYPES
type TemplateDocumentTypes =
  (typeof TEMPLATE_DOCUMENT_TYPES)[TemplateDocumentTypesKeys]

const TEMPLATE_DOCUMENT_TYPES_OBJ: Record<
  string,
  {
    id: TemplateDocumentTypes
    value: TemplateDocumentTypes
    label: string
    style: React.CSSProperties
  }
> = {
  [TEMPLATE_DOCUMENT_TYPES.PROPOSAL_CONTRACT]: {
    id: TEMPLATE_DOCUMENT_TYPES.PROPOSAL_CONTRACT,
    value: TEMPLATE_DOCUMENT_TYPES.PROPOSAL_CONTRACT,
    label: "Proposal & Contract",
    style: {
      color: "#2196F3",
      backgroundColor: "#E3F2FD",
      borderColor: "#E3F2FD"
    }
  },
  [TEMPLATE_DOCUMENT_TYPES.PROPOSAL]: {
    id: TEMPLATE_DOCUMENT_TYPES.PROPOSAL,
    value: TEMPLATE_DOCUMENT_TYPES.PROPOSAL,
    label: "Proposal",
    style: {
      color: "#9C27B0",
      backgroundColor: "#F3E5F5",
      borderColor: "#F3E5F5"
    }
  },
  [TEMPLATE_DOCUMENT_TYPES.CONTRACT]: {
    id: TEMPLATE_DOCUMENT_TYPES.CONTRACT,
    value: TEMPLATE_DOCUMENT_TYPES.CONTRACT,
    label: "Contract",
    style: {
      color: "#2E7D32",
      backgroundColor: "#C8E6C9",
      borderColor: "#C8E6C9"
    }
  }
}

const TEMPLATE_DOCUMENT_TYPES_MAP = Object.fromEntries(
  Object.values(TEMPLATE_DOCUMENT_TYPES_OBJ).map((item) => [item.label, item])
) as Record<
  string,
  (typeof TEMPLATE_DOCUMENT_TYPES_OBJ)[keyof typeof TEMPLATE_DOCUMENT_TYPES_OBJ]
>

const TEMPLATE_DOCUMENT_TYPES_LIST = Object.values(TEMPLATE_DOCUMENT_TYPES_OBJ)

export {
  TEMPLATE_DOCUMENT_TYPES,
  TEMPLATE_DOCUMENT_TYPES_OBJ,
  TEMPLATE_DOCUMENT_TYPES_MAP,
  TEMPLATE_DOCUMENT_TYPES_LIST,
  type TemplateDocumentTypes
}
